import localStorageHelper from '@/helpers/localStorageHelper'

export default {
  getDataLayer: function ()
  {
    return window.dataLayer || []
  },
  processProducts: function (products)
  {
    const resultProducts = []
    try
    {
      products.forEach(function (product)
        {
          // console.log('Got product:', product)
          const resultProduct = {
            name: product.loan_ref + ' ' + product.loan_type,
            id: product.loan_ref,
            brand: product.loan_originator_name,
            category: product.loan_type
          }
          if (product.amount)
          {
            resultProduct.price = 1
            resultProduct.quantity = product.amount
          }
          if (product.invested_amount)
          {
            resultProduct.invested_amount = product.invested_amount
            resultProduct.quantity = product.invested_amount // override product quantity
          }
          if (product.investment_id)
          {
            resultProduct.investment_id = product.investment_id
          }
          resultProducts.push(resultProduct)
        }
      )
    } catch (e)
    {
      console.error('Problem with processing of products: ', e)
    }
    return resultProducts
  },
  clearDataLayer: function ()
  {
    // console.log('run clearDataLayer')
    const dataLayer = this.getDataLayer()
    dataLayer.forEach(function (layer, index)
    {
      if (layer.event && (['addToCart', 'removeFromCart', 'prodDetail', 'purchase'].includes(layer.event))) {
        // console.log('Delete:', layer)
        delete dataLayer[index]
      }
    })
  },
  pushToDataLayer: function (event, products, params = {})
  {
    const dataLayer = this.getDataLayer()
    const resultObject = {}
    let actionField = null
    let eventAction = 'action'
    this.clearDataLayer()
    switch (event)
    {
      case 'addToCart':
        eventAction = 'add'
        break
      case 'removeFromCart':
        eventAction = 'remove'
        break
      case 'prodDetail':
        eventAction = 'detail'
        actionField = {list: params.list}
        break
      case 'purchase':
        eventAction = 'purchase'
        actionField = {
          id: params.transactionId, // Transaction ID.
          revenue: params.invested // Total transaction value
        }
        break
    }
    products = this.processProducts(products)
    const ecommerce = {
      // Hardcoded. Previously was currencyCode: products[n].loan_currency
      currencyCode: 'EUR'
    }

    if (actionField)
    {
      ecommerce[eventAction] = {
        actionField: actionField,
        products: products
      }
    }
    else
    {
      ecommerce[eventAction] = {
        products: products
      }
    }
    resultObject.event = event
    resultObject.ecommerce = ecommerce
    dataLayer.push(resultObject)
   // console.log('dataLayer:', dataLayer)
  },
  pushEvent: function (eventName)
  {
    const dataLayer = this.getDataLayer()
    const resultObject = {
      event: eventName
    }
    dataLayer.push(resultObject)
  },
  pushLoginEvent: function (eventName, serviceUsed, failReason = null)
  {
    const dataLayer = this.getDataLayer()
    const resultObject = {
      event: eventName,
      serviceUsed: serviceUsed
    }
    if (failReason) {
      resultObject.failReason = failReason
    }
    // console.log('Page: ', window.location.href)
    // console.log('RUN pushLoginEvent:', eventName, serviceUsed, failReason)
    // console.log(resultObject)
    dataLayer.push(resultObject)
    localStorageHelper.remove('loginProvider')
    localStorageHelper.remove('login_success')
    localStorageHelper.remove('login_fail')
  }
}
